import React from 'react';
import {
  IQRCodeContentCommonProps,
  QRCodeContentLocalStorageKeys,
  QRCodeContentNavigationActions,
  QRCodeScreenTypes,
} from '../../QRCodeCommonComponentEnums';
import QRCodeContentViewWrapper from '../QRCodeViewWrapper';
import { useTranslation } from 'react-i18next';
import DeliveryDashboardBottomSheet from '@src/pages/DeliveryDashboard/components/DeliveryDashboardBottomSheet';
import styles from './QRCodeRegenerateContent.module.scss';
import PIEText from '@src/shared/components/PIEText';
import { IconArrowLeft } from '@justeattakeaway/pie-icons-react';
import PIEModal from '@src/shared/components/PIEModal';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIECheckbox from '@src/shared/components/PIECheckbox';
import PIEButton from '@src/shared/components/PIEButton';

interface componentProps extends IQRCodeContentCommonProps {}

const QRCodeRegenerateContent = ({ bottomSheetView, popupView, onNavigate }: componentProps) => {
  const { t } = useTranslation();

  const [checkboxSelected, setCheckboxSelected] = React.useState<boolean>(false);

  const onBackHandler = () => {
    onNavigate?.(QRCodeContentNavigationActions.JUMP_SCREEN, QRCodeScreenTypes.SHOW_QR_CODE);
  };
  const onCloseHandler = () => {
    onNavigate?.(QRCodeContentNavigationActions.CLOSE);
  };
  const handleConfirm = () => {
    const { QR_CODE_REGENERATE_DONT_SHOW_AGAIN } = QRCodeContentLocalStorageKeys;
    if (checkboxSelected) {
      localStorage.setItem(QR_CODE_REGENERATE_DONT_SHOW_AGAIN, 'true');
    } else {
      localStorage.removeItem(QR_CODE_REGENERATE_DONT_SHOW_AGAIN);
    }
    onNavigate?.(QRCodeContentNavigationActions.JUMP_SCREEN, QRCodeScreenTypes.SHOW_QR_CODE, {
      regenerate: true,
    });
  };

  const renderContent = () => {
    return (
      <>
        <PIEComponentUtil marginBottom="var(--xds-spacing-d)">
          <PIEText
            size={'var(--xds-font-size-14)'}
            fontWeight="var(--xds-font-weight-bold)"
            text={t('ocf_screens.QR_CODE_REGENERATE_TITLE')}
          />
          <PIEText
            size={'var(--xds-font-size-14)'}
            fontWeight="var(--xds-font-weight-regular)"
            text={t('ocf_screens.QR_CODE_REGENERATE_DESCRIPTION')}
          />
        </PIEComponentUtil>
        <PIEComponentUtil marginBottom="var(--xds-spacing-f)">
          <PIECheckbox
            onChange={(selectionStatus: any) => setCheckboxSelected(selectionStatus)}
            checked={checkboxSelected}
          >
            <PIEText
              text={t('ocf_screens.QR_CODE_REGENERATE_DONT_SHOW_AGAIN')}
              size="var(--xds-font-size-16)"
              fontWeight="var(--xds-font-weight-regular)"
              color="var(--xds-color-content-default)"
            />
          </PIECheckbox>
        </PIEComponentUtil>
        <PIEButton
          autoWidth
          size="medium"
          mode="primary"
          type="button"
          text={t('ocf_screens.QR_CODE_REGENERATE_CONFIRM_BUTTON')}
          onClick={() => handleConfirm()}
        ></PIEButton>
      </>
    );
  };

  const renderDesktopView = (content: React.ReactNode) => {
    return (
      <PIEModal isOpen={true} size="small" modOverlay>
        <PIEModal.Header
          showBack
          onBackClick={onBackHandler}
          onClose={() => onNavigate?.(QRCodeContentNavigationActions.CLOSE)}
          heading={
            <PIEText
              size={'var(--xds-font-size-24)'}
              fontWeight="var(--xds-font-weight-extrabold)"
              text={t('ocf_screens.QR_CODE_CONNECT_COURIER_TITLE')}
            />
          }
        />
        <PIEModal.Content>{content}</PIEModal.Content>
      </PIEModal>
    );
  };

  const renderMobileView = (
    content: React.ReactNode,
    overrideBlockingValue?: boolean | undefined
  ) => {
    return (
      <DeliveryDashboardBottomSheet
        blocking={overrideBlockingValue !== undefined ? overrideBlockingValue : true}
        constantHeight={300}
        onBottomSheetHeight={() => {}}
        showCloseButton
        onClose={onCloseHandler}
        header={
          <div className={styles.mobileBottomSheetHeader}>
            <IconArrowLeft size="m" onClick={onBackHandler} />
            <PIEText
              align="left"
              size={'var(--xds-font-size-20)'}
              fontWeight="var(--xds-font-weight-extrabold)"
              text={t('ocf_screens.QR_CODE_CONNECT_COURIER_TITLE')}
            />
          </div>
        }
      >
        <PIEComponentUtil padding="var(--xds-spacing-d)">{content}</PIEComponentUtil>
      </DeliveryDashboardBottomSheet>
    );
  };

  return (
    <QRCodeContentViewWrapper
      content={renderContent()}
      bottomSheetView={bottomSheetView}
      popupView={popupView}
      bottomSheetWrapper={renderMobileView}
      popupWrapper={renderDesktopView}
    />
  );
};

export default QRCodeRegenerateContent;
